import { Flame } from "lucide-react"

interface StreakCardProps {
  current: number
  best: number
}

export function StreakCard({ current, best }: StreakCardProps) {
  return (
    <div
      className="insight-card rounded-2xl p-4"
      style={{
        background: "var(--fig-card-bg)",
        boxShadow: "var(--fig-card-shadow)",
        border: "1px solid var(--fig-card-border)",
      }}
    >
      <div className="flex items-center gap-3">
        <div
          className="flex shrink-0 items-center justify-center"
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            background: "var(--fig-entry-mood-bg)",
          }}
        >
          <Flame size={20} style={{ color: "var(--fig-entry-mood-icon)" }} />
        </div>
        <div>
          {current === 0 ? (
            <p
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: "var(--fig-text-primary)",
              }}
            >
              No streak yet
            </p>
          ) : (
            <p
              style={{
                fontSize: 15,
                fontWeight: 700,
                color: "var(--fig-text-primary)",
              }}
            >
              {current} day{current !== 1 ? "s" : ""} streak
            </p>
          )}
          {best > 0 && (
            <p
              style={{
                fontSize: 12,
                color: "var(--fig-text-inactive)",
                marginTop: 2,
              }}
            >
              Best: {best} day{best !== 1 ? "s" : ""}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
